"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var social_groups_api_1 = require("@wix/social-groups-api");
var types_1 = require("@wix/social-groups-api/dist/src/types");
var baseUrl_1 = require("@wix/social-groups-common/dist/src/baseUrl");
var routeParams_1 = require("./routeParams");
function getFirstGroup(apiClient) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var groups;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiClient.getGroupList()];
                case 1:
                    groups = (_a.sent()).data.groups;
                    return [2 /*return*/, groups[groups.length - 1]];
            }
        });
    });
}
exports.getFirstGroup = getFirstGroup;
exports.DEFAULT_APPS = (_a = {},
    _a[types_1.ApiTypes.v1.GroupAppKey.ABOUT_APP] = {
        key: types_1.ApiTypes.v1.GroupAppKey.ABOUT_APP,
        installed: true,
    },
    _a[types_1.ApiTypes.v1.GroupAppKey.FEED_APP] = {
        key: types_1.ApiTypes.v1.GroupAppKey.FEED_APP,
        installed: true,
    },
    _a[types_1.ApiTypes.v1.GroupAppKey.GALLERY_APP] = {
        key: types_1.ApiTypes.v1.GroupAppKey.GALLERY_APP,
        installed: true,
    },
    _a[types_1.ApiTypes.v1.GroupAppKey.MEMBERS_APP] = {
        key: types_1.ApiTypes.v1.GroupAppKey.MEMBERS_APP,
        installed: true,
    },
    _a);
function getApi(controllerConfig) {
    var instance = controllerConfig.appParams.instance, wixCodeApi = controllerConfig.wixCodeApi;
    return new social_groups_api_1.default(instance, baseUrl_1.default(wixCodeApi));
}
exports.getApi = getApi;
function getCachedGroup(controllerConfig, groupId) {
    try {
        var _group = controllerConfig.platformAPIs.storage.memory.getItem(groupId);
        var group = JSON.parse(_group);
        var isValidGroup = group.groupId === groupId || group.slug === groupId;
        return isValidGroup && group;
    }
    catch (e) {
        console.log('Failed to get group from storage');
    }
}
function getGroupFromLocation(controllerConfig) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var location, groupId, api, cachedGroup, group, e_1, firstGroup, data;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    location = controllerConfig.wixCodeApi.location;
                    groupId = isEditorMode(controllerConfig)
                        ? getGroupIdFromAppSectionParams()
                        : routeParams_1.groupRoute(location).groupId;
                    api = getApi(controllerConfig);
                    if (!groupId) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    cachedGroup = getCachedGroup(controllerConfig, groupId);
                    if (cachedGroup) {
                        return [2 /*return*/, cachedGroup];
                    }
                    return [4 /*yield*/, api.getGroup(groupId)];
                case 2:
                    group = (_a.sent()).data.group;
                    return [2 /*return*/, group];
                case 3:
                    e_1 = _a.sent();
                    console.log("Failed to get group " + groupId);
                    return [3 /*break*/, 4];
                case 4: return [4 /*yield*/, getFirstGroup(api)];
                case 5:
                    firstGroup = _a.sent();
                    if (!!firstGroup) return [3 /*break*/, 7];
                    return [4 /*yield*/, api.getDefaultGroup()];
                case 6:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data.group];
                case 7: return [2 /*return*/, firstGroup];
            }
        });
    });
}
exports.getGroupFromLocation = getGroupFromLocation;
function getDefaultPost(controllerConfig) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var post, api, data, e_2;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    post = getEmptyPost();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    api = getApi(controllerConfig);
                    return [4 /*yield*/, api.getDefaultPostContent()];
                case 2:
                    data = (_a.sent()).data;
                    post.entity.body.content = data;
                    return [2 /*return*/, post];
                case 3:
                    e_2 = _a.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, post];
            }
        });
    });
}
exports.getDefaultPost = getDefaultPost;
function isEditorMode(controllerConfig) {
    var viewMode = controllerConfig.wixCodeApi.window.viewMode;
    return ['Editor', 'Preview'].includes(viewMode);
}
function getGroupIdFromAppSectionParams() {
    var groupId = '';
    try {
        // can not use controllerConfig.wixCode.location, because appSections params is missed here,
        // they only present in iframe src.
        groupId = new URL(window.location).searchParams.get('groupId');
    }
    catch (e) {
        // ...
    }
    return groupId;
}
function getEmptyPost() {
    return {
        attachments: [],
        comments: undefined,
        createdAt: undefined,
        createdBy: '',
        entity: {
            body: {
                content: undefined,
                contentType: types_1.SocialApiTypes.ContentType.DRAFTJS,
            },
        },
        feedItemId: '',
        pin: undefined,
        reactions: {
            total: 0,
            usersReactions: {
                total: 0,
                reactions: [],
            },
            usersReacted: {
                total: 0,
                userIds: [],
            },
        },
        requesterContext: undefined,
    };
}
//# sourceMappingURL=helpers.js.map